__turbopack_context__.v({
  "preview": "preview-module__5uDx_q__preview",
  "preview__background": "preview-module__5uDx_q__preview__background",
  "preview__background_cover": "preview-module__5uDx_q__preview__background_cover",
  "preview__background_image": "preview-module__5uDx_q__preview__background_image",
  "preview__button": "preview-module__5uDx_q__preview__button",
  "preview__content": "preview-module__5uDx_q__preview__content",
  "preview__logo": "preview-module__5uDx_q__preview__logo",
  "preview__logo_image": "preview-module__5uDx_q__preview__logo_image",
  "preview__logo_text": "preview-module__5uDx_q__preview__logo_text",
});
